// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"e2a91c61","160":"6e37e6e4"}[chunkId] + ".chunk.css";
};